import { nanoid } from 'nanoid';
import { type ReactNode, useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import { EditorMode } from '~/common/types';
import EditorSurface from '~/components2/Map/canvas/EditorSurface';
import { mapState } from '~/components2/Map/Map';
import { homeMapStore } from '../store';

export default function DrawSurface() {
  const map = useMap();

  const containerDiv = useRef<HTMLDivElement>(null);

  const { editorMode } = useSnapshot(homeMapStore) as typeof homeMapStore;

  const content: ReactNode = null;

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (containerDiv.current && map.current && editorMode !== EditorMode.None) {
      const surface = new EditorSurface({
        id: `editor-surface-${nanoid()}`,
        container: containerDiv.current,
        map: map.current.getMap(),
        store: homeMapStore,
      });

      const unsubscribe = subscribe(mapState, () => surface.refreshScreenCoords());

      const unsubscribeStore = subscribe(homeMapStore, () => {
        if (!homeMapStore.currentObject) return;
      });

      return () => {
        unsubscribe();
        unsubscribeStore();
        surface.destroy();
      };
    }
  }, [editorMode]);

  if (!map.current) {
    return null;
  }

  if (editorMode === EditorMode.None) {
    return null;
  }

  return (
    <div style={{ cursor: '-moz-grab' }} className={'absolute left-0 top-0'} ref={containerDiv}>
      {content}
    </div>
  );
}
